<script>
    import { createEventDispatcher } from 'svelte';

    import Date from './Date.svelte';
    import Hours from './Hours.svelte';
    import Landings from './Landings.svelte';
    import Cycles from './Cycles.svelte';

    import {
        isLandingsAvailable as getIsLandingsAvailable,
        isCyclesAvailable as getIsCyclesAvailable,
    } from 'src/core/state';

    export let equipmentType;
    export let form;
    export let state;

    export let dateFieldName;
    export let hoursFieldName;
    export let landingsFieldName;
    export let cyclesFieldName;

    export let date;
    export let hours;
    export let landings;
    export let cycles;

    export let isDateRequired = false;
    export let isHoursRequired = false;
    export let isLandingsRequired = false;
    export let isCyclesRequired = false;

    export let isDisabled = false;

    const dispatch = createEventDispatcher();

    const onChange = (fieldName, value) => dispatch('change', {
        fieldName,
        value,
    });

    $: isLandingsAvailable = getIsLandingsAvailable(equipmentType);
    $: isCyclesAvailable = getIsCyclesAvailable(equipmentType);

    $: onChange(dateFieldName, date);
    $: onChange(hoursFieldName, hours);
    $: onChange(landingsFieldName, landings);
    $: onChange(cyclesFieldName, cycles);
</script>

<div>
    <Date
        {state}
        fieldName={dateFieldName}
        disabled={isDisabled}
        required={isDateRequired}
        bind:value={date}
    />
    <Hours
        {state}
        fieldName={hoursFieldName}
        disabled={isDisabled}
        required={isHoursRequired}
        bind:value={hours}
    />

    {#if isLandingsAvailable}
        <Landings
            {state}
            fieldName={landingsFieldName}
            disabled={isDisabled}
            required={isLandingsRequired}
            bind:value={landings}
        />
    {/if}

    {#if isCyclesAvailable}
        <Cycles
            {state}
            fieldName={cyclesFieldName}
            disabled={isDisabled}
            required={isCyclesRequired}
            bind:value={cycles}
        />
    {/if}
</div>
